import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { FormControl } from '@angular/forms';
import { isStringEmpty } from '@common/helpers';
import {
  WHEEL_CHAIR_BATTERY_CODE,
  WHEEL_CHAIR_MANUAL_CODE,
} from '@common/helpers/constants/my-booking/passenger-information-input-modal.constant';
import { SpecialAssistanceRequestState } from '@common/helpers/constants/my-booking/passenger-information-input-modal.state';
import { MListData } from '@common/interfaces';
import { SpecialAssistanceRequestWheelchairTypeData } from '@common/interfaces/mybooking/modals/passenger-information-input/special-assistance-request-modal.interface';
import { PassengerInformationInputModalCommonService } from '@common/services/my-booking/passenger-information-input-modal/passenger-information-input-modal.common.service';
import { AswValidators } from '@lib/helpers';
import { ValidationErrorInfo } from '@lib/interfaces/validate';

/**
 * サポート情報入力モーダル
 */
@Component({
  selector: 'asw-special-assistance-request-modal-wheelchair-type',
  templateUrl: './special-assistance-request-modal-wheelchair-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialAssistanceRequestModalWheelchairTypeComponent implements OnInit, OnDestroy {
  @Input()
  get data() {
    return this._data;
  }
  set data(value: SpecialAssistanceRequestWheelchairTypeData | undefined) {
    this._data = value;
  }
  private _data?: SpecialAssistanceRequestWheelchairTypeData;

  @Output()
  dataChange: EventEmitter<SpecialAssistanceRequestWheelchairTypeData> =
    new EventEmitter<SpecialAssistanceRequestWheelchairTypeData>();

  @Input()
  get master(): Array<MListData> {
    return this._master;
  }
  set master(value: Array<MListData>) {
    this._master = value;
  }
  private _master: Array<MListData> = [];

  public id = this.constructor.name;
  public type: string = '';
  public batteryTypeFc = new FormControl('', [AswValidators.required(SpecialAssistanceRequestState.BatteryType)]);
  public selectError: ValidationErrorInfo | null = null;
  public selectBatteryError: ValidationErrorInfo | null = null;

  public wheelchairTypeSelectList = [
    { value: WHEEL_CHAIR_MANUAL_CODE, label: 'label.manual' },
    { value: WHEEL_CHAIR_BATTERY_CODE, label: 'label.electric' },
  ];

  public WHEEL_CHAIR_BATTERY_CODE = WHEEL_CHAIR_BATTERY_CODE;

  constructor(private _change: ChangeDetectorRef, private _s04CommonSvc: PassengerInformationInputModalCommonService) {}

  ngOnInit(): void {
    this.refresh();
  }

  ngOnDestroy(): void {
    this.apply();
  }

  refresh() {
    this.type = this.data?.type ?? '';
    this.batteryTypeFc.setValue(this.data?.batteryType ?? '');

    this._change.markForCheck();
  }

  apply() {
    if (!this.data) {
      return;
    }

    this.data.type = this.type;
    this.data.batteryType = this._s04CommonSvc.getWheelchairBatteryDisplayValue(this.batteryTypeFc.value ?? '');

    this.dataChange.emit(this.data);
  }

  /**
   * エラー判定
   * @returns エラー判定結果
   */
  isError() {
    let isError = false;

    if (this.type === '') {
      this.selectError = SpecialAssistanceRequestState.WheelchairType;
      isError = true;
    }

    if (this.type === WHEEL_CHAIR_BATTERY_CODE && this.batteryTypeFc.errors) {
      this.selectBatteryError = SpecialAssistanceRequestState.BatteryType;
      isError = true;
    }

    return isError;
  }

  // (40) 車いす種類の値更新処理　※サポート情報入力モーダル(車いす種類・バッテリータイプグループ)
  typeChange(type: string) {
    if (!isStringEmpty(type)) {
      this.type = type;
      this.selectError = null;
      this.apply();
    }
  }

  batteryTypeChange() {
    if (!this.isError()) this.selectBatteryError = null;
  }
}
